import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";
import { CatchmentKpiRequest, CatchmentRequest } from "./summary.types";

export const summaryApi = api
  .enhanceEndpoints({ addTagTypes: ["summary"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      summary: builder.query({
        query: (catchmentRequest: CatchmentRequest) => {
          return {
            url: `kpi/summary/getData`,
            method: RequestMethod.GET,
          };
        },
      }),
      summaryExport: builder.mutation({
        query: (catchmentRequest: CatchmentRequest) => {
          return {
            url: `admin/catchment/export`,
            method: "POST",
            body: {
              ...catchmentRequest,
            },
            responseHandler: (response) => response.blob(), // Maneja la respuesta como un blob
          };
        },
      }),
      catchmentKpi: builder.query({
        query: (catchmentKpiRequest: CatchmentKpiRequest) => {
          return {
            url: `admin/catchment/kpis`,
            method: RequestMethod.POST,
            body: {
              ...catchmentKpiRequest,
            },
          };
        },
      }),
    }),
  });

export const {
  useSummaryQuery,
  useSummaryExportMutation,
  useCatchmentKpiQuery,
  useLazyCatchmentKpiQuery,
} = summaryApi;
